import { render, staticRenderFns } from "./BaseHomeContent.vue?vue&type=template&id=49a97804"
import script from "./BaseHomeContent.vue?vue&type=script&lang=js"
export * from "./BaseHomeContent.vue?vue&type=script&lang=js"
import style0 from "./BaseHomeContent.vue?vue&type=style&index=0&id=49a97804&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports